
<template>
  <v-file-input :accept='type' :error-messages="error" label="Profile Image"  @change="changeData($event)"  dense outlined  prepend-icon=""></v-file-input>
</template>

<script>
export default {
  name: "FileUpload",
  props: ['type', 'error'],

  methods: {
    changeData(event) {
      this.$emit("changeFile", event);
    }
  }
};
</script>